<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import moment from "moment";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Purchase Returns Report Today",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,    
  },
  data() {
    return {
      filterTitle:'Purchase Returns Report',
      data: {
        datefrom: '',
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        product:''
      },
      currentdate:moment(new Date()).format("YYYY-MM-DD"),
      title: "Purchase Returns Report Today",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Purchase Returns Report Today",
          active: true,
        },
      ],
      totalRows: 1,
      totals:{
        totalAmount:0
      },
      currentPage: 1,
      perPage: 10,
      filteredReport:[],
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product.product_name",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit_price_no",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT REFUNDED",
        },
        {
          key: "reason",
          sortable: true,
          label: "REASON",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "type",
          sortable: true,
          label: "TYPE",
        },
        {
          key: "user.name",
          sortable: true,
          label: "RECORDED BY",
        },
      ],
      json_fields: {
        PRODUCT_NAME: "product.product_name",
        QUANTITY: "quantity",
        UNIT_PRICE: "unit_price",
        AMOUNT_REFUNDED: "amount",
        MODE: "mode",
        REASON: "reason",
        DATE: "date",
        TYPE: "type",
        RECORDED_BY: "user.name",
        RECORDED_ON: "date_recorded",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("purchase", ["PurchasesReturn"]),
    ...mapGetters("products", ["Products"]),


    /**
     * Total no. of records
     */

    rows() {
      return this.filteredReport ? this.filteredReport.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.PurchasesReturn ? this.PurchasesReturn.length : 1;
  },
  methods: {
    ...mapActions({
      FetchReturns: "purchase/fetchReturns",
      FetchProducts: "products/fetchProducts",

    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    filterReport() {
      this.totals.totalAmount = 0;
      let date2 = this.data.dateto;
      let date1 = this.data.datefrom;
      let total = 0;
      this.filteredReport = this.PurchasesReturn.filter((element) => {
        if (this.data.product != "" && this.data.datefrom == "" && this.data.dateto != "") {
          if (element.product.id == this.data.product && element.date <= date2) {
            let amt = parseInt(element.amount);
            total = total + amt;
            this.totals.totalAmount = total;
          }
          this.Products.filter((element) => {
            if (element.id == this.data.product) {
              let expcat = element.name;
              this.filterTitle =
                "Purchase Returns Report For " + expcat + " Up To " + this.data.dateto;
            }
          });

          return element.product.id == this.data.product && element.date <= date2;
        } else if (
          this.data.product == "" &&
          this.data.datefrom != "" &&
          this.data.dateto != ""
        ) {
          this.filterTitle =
            "Purchase Returns Report From " + this.data.datefrom + " To " + this.data.dateto;
          if (element.date >= date1 && element.date <= date2) {
            let amt = parseInt(element.amount);
            total = total + amt;
            this.totals.totalAmount = total;
          }

          return element.date >= date1 && element.date <= date2;
        } else if (
          this.data.product != "" &&
          this.data.datefrom != "" &&
          this.data.dateto != ""
        ) {
          if (
            element.product.id == this.data.product &&
            element.date >= date1 &&
            element.date <= date2
          ) {
            let amt = parseInt(element.amount);
            total = total + amt;
            this.totals.totalAmount = total;
          }

          this.Products.filter((element) => {
            if (element.id == this.data.product) {
              let expcatx = element.name;
              this.filterTitle =
                "Purchase Returns Report For " +
                expcatx +
                " From " +
                this.data.datefrom +
                " To " +
                this.data.dateto;
            }
          });

          return (
            element.product.id == this.data.product &&
            element.date >= date1 &&
            element.date <= date2
          );
        }
      });
    },
    assiginData() {
      this.filteredReport = this.PurchasesReturn;

      let total = 0;
      this.PurchasesReturn?this.PurchasesReturn.forEach((value) => {
        let amt = parseInt(value.amount);
        total = total + amt;
      }):[];
      this.totals.totalAmount = total;
    },
  },
  watch: {
    PurchasesReturn(newValue){
      if(newValue){
        this.assiginData();
      }
    },
  },
  created() {
    this.FetchReturns();
    this.FetchProducts();
    this.assiginData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="filterTitle"></h3>
              </div>

            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <download-excel
                  class="btn btn-info"
                  :data="filteredReport"
                  :fields="json_fields"
                  :worksheet="'PURCHASE RETUNRS REPORT ON' + currentdate"
                  type="csv"
                  :name="'Purchase_returns' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-md-3 form-group mb-2">
                <label>FROM</label>
                <input
                  @change="filterReport()"
                  type="date"
                  v-model="data.datefrom"
                  class="form-control"
                />
              </div>
              <div class="col-md-3 form-group">
                <label>TO</label>
                <input
                  @change="filterReport()"
                  v-model="data.dateto"
                  type="date"
                  class="form-control"
                />
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>Product</label>
                  <model-list-select
                    :list="Products ? Products : []"
                    v-model="data.product"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Product"
                    @input="filterReport()"
                  >
                  </model-list-select>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="filteredReport?filteredReport:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(amount)="data">
                  {{ thousandSeperator(data.item.amount) }}
                </template>
              </b-table>
              <div class="row">
                  <div class="col-md-2"></div>
                  <div class="col-md-6">
                    <h5>Total Amount Refunded: <span class="text-danger">{{thousandSeperator(totals.totalAmount)}}</span></h5>
                  </div>
                </div>
            </div>
            <Loader  v-if="!filteredReport"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
